import React, { useEffect, useState } from "react";
import { Toolbar, Typography, Box } from "@mui/material";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import { EmailLogType } from "../../../types/genericType";
import EmailLogTable from "../../../components/emailLogTable/EmailLogTable";
import { getEmailLogs } from "../../../services/logsService";

const EmailLog = () => {
  const [search, setSearch] = useState("");
  const [emailLogs, setEmailLogs] = useState<EmailLogType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const initialLoad = () => {
    setIsLoading(true);
    getEmailLogs()
      .then((res) => {
        const dataWithIds = res.map((email, index) => ({
          ...email,
          id: `email-${index}`,
        }));
        setIsLoading(false);
        setEmailLogs(dataWithIds);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    initialLoad();
  }, []);

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSearch(event.target.value);
  };

  const clearSearch = () => {
    setSearch("");
  };

  const filteredData = emailLogs.filter((log: any) => {
    return (
      log.email.toLowerCase().includes(search.toLowerCase()) ||
      log.subject.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Email Log
        </Typography>
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        {isLoading ? (
          <TableRowsLoader rowsNum={10} />
        ) : emailLogs.length > 0 ? (
          <EmailLogTable
            data={filteredData}
            search={search}
            onSearchChange={handleSearchChange}
            clearSearch={clearSearch}
          />
        ) : (
          <Typography>No Email Log records found</Typography>
        )}
      </Box>
    </>
  );
};

export default EmailLog;
